// map
import { createContext, useContext } from 'react';

export const MapContext = createContext(null)

export const useMapState = () => useContext(MapContext)

//charger
export const ChargerContext = createContext(null)

export const useChargerState = () => useContext(ChargerContext)

// localization
export const LocalizationContext = createContext(null)

export const useLocalizationState = () => useContext(LocalizationContext)

// auth
export const AuthContext = createContext(null)

export const useAuthState = () => useContext(AuthContext)